module.exports = __webpack_public_path__ + "static/media/AccountMyData.579436bf.png";